import blocks from './blocks';
import components from './components';

export default (editor, config) => {
  blocks(editor, config);
  components(editor, config);
};
